import { initializeApp } from '@firebase/app';
import { 
  getFirestore, 
  enableIndexedDbPersistence,
  CACHE_SIZE_UNLIMITED,
  initializeFirestore
} from '@firebase/firestore';
import { getAuth } from '@firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyALzYdlqlZwvqAnA-osapuNDyoM0EC5AB0",
  authDomain: "momoh-b3eb7.firebaseapp.com",
  projectId: "momoh-b3eb7",
  storageBucket: "momoh-b3eb7.firebasestorage.app",
  messagingSenderId: "110594972534",
  appId: "1:110594972534:web:220dcc55ade7a65181f857"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firestore with enhanced cache settings
const db = initializeFirestore(app, {
  cacheSizeBytes: CACHE_SIZE_UNLIMITED,
  experimentalForceLongPolling: true, // Ensures better compatibility across browsers
});

// Enable persistence with robust error handling
const enablePersistence = async () => {
  try {
    await enableIndexedDbPersistence(db);
    console.log('Offline persistence enabled successfully');
  } catch (err) {
    if (err.code === 'failed-precondition') {
      // Multiple tabs might be open, persistence can only be enabled in one tab at a time
      console.warn(
        'Firebase persistence failed to enable. This can occur when multiple tabs are open. ' +
        'Falling back to online-only mode.',
        err
      );
    } else if (err.code === 'unimplemented') {
      // The current browser doesn't support persistence
      console.warn(
        'The current browser does not support offline persistence. ' +
        'Falling back to online-only mode.',
        err
      );
    } else {
      console.error('Unexpected error enabling Firebase persistence:', err);
    }
  }
};

// Initialize persistence
enablePersistence().catch(err => {
  console.warn('Could not enable persistence. App will continue without offline capabilities:', err);
});

const auth = getAuth(app);

export { db, auth };